<template>
  <b-input
    v-if="field.type === NUMERIC"
    v-model="unit"
    type="text"
  />
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldTypes, FieldMapItem, FieldCalculationV2Config } from '@/types'

const props = {
  field: {
    type: Object as PropType<FieldMapItem | FieldCalculationV2Config>,
    required: true,
  },
}

@Component
export default class UpdateFieldUnit extends Vue.extend({ props }) {
  NUMERIC = FieldTypes.NUMERIC

  get unit () {
    return this.field.unit
  }

  set unit (value) {
    this.field.unit = value
  }
}

</script>
